import React, { useState } from 'react'
import MaskedInput from 'react-text-mask'

import { Button } from '@leasequery/lq.react-component-library'
import { verifyDates } from '../../utils/Dates.jsx'

import '../form/RitForm.css'

export default function RitForm({
	navigateForward,
	navigateBack,
	setErrorMessage,
	errorMessage,
	value,
	subValue,
}) {
	const [startDate, setStartDate] = useState(value ? value : '')
	const [endDate, setEndDate] = useState(subValue ? subValue : '')

	return (
		<div>
			<div className='date-form'>
				<div className='form'>
					<MaskedInput
						className='date-input'
						onChange={(e) => {
							setStartDate(e.target.value)
						}}
						value={startDate ? startDate : ''}
						placeholder='mm/dd/yyyy'
						mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
						placeholderChar={'\u2000'}
						name='startDate'
						id='startDate'
					/>
					<label htmlFor='name' className='label-name'>
						<span className='content-name'>Lease Start Date</span>
					</label>
				</div>
				<div className='form'>
					<MaskedInput
						className='date-input'
						onChange={(e) => {
							setEndDate(e.target.value)
						}}
						value={endDate ? endDate : ''}
						placeholder='mm/dd/yyyy'
						mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
						placeholderChar={'\u2000'}
						name='endDate'
						id='endDate'
					/>
					<label htmlFor='name' className='label-name'>
						<span className='content-name'>Lease End Date</span>
					</label>
				</div>
			</div>
			<div className='errorMessage-Container'>{errorMessage}</div>
			<div>
				<Button
					buttonType='secondary'
					className='form-Button'
					onClick={() => navigateBack()}
				>
					Back
				</Button>
				<Button
					buttonType='primary'
					className='form-Button'
					onClick={() =>
						verifyDates(startDate, endDate, setErrorMessage, navigateForward)
					}
				>
					Next
				</Button>
			</div>
		</div>
	)
}
